export const ERROR_STRING = 'Oops, there was a problem'

export const errors = {
  GENERAL_ERROR: ERROR_STRING,
  CHECK_FIELD_OPTIONS: ERROR_STRING + ' requesting your field settings',
  PREPARE_USER_FIELDS: ERROR_STRING + ' requesting your user fields',
  FIELD_OPTIONS: ERROR_STRING + ' requesting your user field options',
}
